<template>
  <div class="home">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-slider">
        <div class="swiper hero-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(slide, index) in heroSlides" :key="index" :style="{ backgroundImage: `url(${require('@/assets' + slide.image)})` }"></div>
          </div>
          <!-- Optional navigation -->
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="hero-overlay"></div>
      <div class="container h-100 position-relative" style="z-index: 2">
        <div class="row h-100 align-items-center">
          <div class="col-lg-8 mx-auto text-center" data-aos="fade-up">
            <div class="hero-content">
              <h1 class="hero-title mb-4">Металлообработка полного цикла</h1>
              <p class="hero-subtitle mb-5">Превращаем металл в готовые решения для вашего бизнеса. Современное оборудование, опытная команда и индивидуальный подход к каждому проекту.</p>
              <div class="d-flex flex-wrap gap-3 justify-content-center">
                <router-link to="/services" class="btn btn-primary btn-lg">
                  <span>Наши возможности</span>
                  <i class="fas fa-arrow-right ms-2"></i>
                </router-link>
                <router-link to="/contacts" class="btn btn-outline-light btn-lg">Связаться с нами</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Partners Section -->
<!--    <section class="partners-section py-5">-->
<!--      <div class="container">-->
<!--        <div class="row text-center mb-4">-->
<!--          <div class="col-12" data-aos="fade-up">-->
<!--            <h2 class="section-title">Нам доверяют</h2>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="partners-container">-->
<!--          <div class="row justify-content-center">-->
<!--            <div class="col-md-3 col-sm-6 mb-4" data-aos="fade-up" data-aos-delay="50">-->
<!--              <div class="partner-item">-->
<!--                <div class="partner-name">АЗ «Раритэк»</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-md-3 col-sm-6 mb-4" data-aos="fade-up" data-aos-delay="100">-->
<!--              <div class="partner-item">-->
<!--                <div class="partner-name">АО «Позис» (Зеленодольск)</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-md-3 col-sm-6 mb-4" data-aos="fade-up" data-aos-delay="150">-->
<!--              <div class="partner-item">-->
<!--                <div class="partner-name">ПАО «КамАЗ»</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-md-3 col-sm-6 mb-4" data-aos="fade-up" data-aos-delay="200">-->
<!--              <div class="partner-item">-->
<!--                <div class="partner-name">АО «Радиозавод» (Пенза)</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <!-- Services Section -->
    <section class="section services-section bg-light">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center" data-aos="fade-up">
            <h2 class="section-title text-center">Наши возможности</h2>
            <p class="company-description">
              <span class="highlight-text">ООО «СТИЛАЙН»</span>
              <span class="main-activity"> — ваш надёжный партнёр в металлообработке.
              Производим готовые детали и узлы для машиностроения, строительства и промышленности.</span>
            </p>
            <p class="tech-description">
              Используем передовые технологии лазерной резки, гибки и сварки.
              Полный цикл производства — от чертежа до готового изделия.
            </p>
          </div>
        </div>

        <div class="services-cards">
          <div
            v-for="(service, index) in services.slice(0, 6)"
            :key="service.id"
            class="service-card"
            :class="{'service-card-with-bg': service.background}"
            :style="service.background ? {'background-image': `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${service.background})`} : {}"
            data-aos="fade-up"
            :data-aos-delay="index * 50"
          >
            <div class="service-icon" :class="{'service-icon-on-bg': service.background}">
              <i :class="'fas fa-' + service.icon"></i>
            </div>
            <h3 class="service-title" :class="{'text-white': service.background}">{{ service.title }}</h3>
            <p class="service-description" :class="{'text-white': service.background}">{{ service.description }}</p>
            <router-link :to="'/services#' + service.id" class="service-link" :class="{'service-link-on-bg': service.background}">
              Подробнее <i class="fas fa-arrow-right icon-arrow"></i>
            </router-link>
          </div>
        </div>

        <div class="text-center mt-5" data-aos="fade-up" data-aos-delay="300">
          <router-link to="/services" class="btn btn-primary btn-lg">
            <span>Смотреть все</span>
            <i class="fas fa-arrow-right ms-2"></i>
          </router-link>
        </div>
      </div>
    </section>

    <!-- About Section -->
    <section class="section about-section about-section-premium">
      <div class="container">
        <div class="about-header text-center mb-5" data-aos="fade-up">
          <div class="about-badge-premium">РАБОТАЕМ С 2012 ГОДА</div>
          <h2 class="about-title-premium">О компании <span class="highlight-brand">STEELINE</span></h2>
          <p class="about-subtitle-premium">Высокоточная металлообработка полного цикла — от чертежа до готового изделия</p>
        </div>

        <div class="about-content-premium" data-aos="fade-up" data-aos-delay="100">
          <div class="row g-0">
            <div class="col-lg-6">
              <div class="about-image-container-premium">
                <div class="video-overlay"></div>
                <video class="about-main-video" autoplay loop muted playsinline>
                  <source src="/img/video_st.mp4" type="video/mp4">
                  Ваш браузер не поддерживает видео.
                </video>
                <div class="video-frame"></div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="about-text-container-premium">
                <div class="about-text-header-premium">
                  <h3>Инновационные решения в металлообработке</h3>
                  <div class="divider-premium"></div>
                </div>

                <p class="about-paragraph-premium">
                  <strong>STEELINE</strong> — это современный производственный комплекс с полным циклом металлообработки. Объединяем передовые технологии, высокоточное оборудование последнего поколения и опытную команду специалистов. Создаём изделия любой сложности с гарантией качества и точным соблюдением сроков.
                </p>

                <div class="about-features-premium">
                  <div class="feature-item-premium">
                    <div class="feature-icon-premium">
                      <i class="fas fa-bolt"></i>
                    </div>
                    <div class="feature-text-premium">Скорость производства в 2 раза выше рынка</div>
                  </div>

                  <div class="feature-item-premium">
                    <div class="feature-icon-premium">
                      <i class="fas fa-bullseye"></i>
                    </div>
                    <div class="feature-text-premium">Прецизионная точность до 0.1 мм</div>
                  </div>

                  <div class="feature-item-premium">
                    <div class="feature-icon-premium">
                      <i class="fas fa-shield-alt"></i>
                    </div>
                    <div class="feature-text-premium">Многоуровневый контроль качества</div>
                  </div>

                  <div class="feature-item-premium">
                    <div class="feature-icon-premium">
                      <i class="fas fa-handshake"></i>
                    </div>
                    <div class="feature-text-premium">Индивидуальные решения для вашего бизнеса</div>
                  </div>
                </div>

                <div class="about-stats-premium">
                  <div class="row g-3">
                    <div class="col-6">
                      <div class="stat-box-premium">
                        <div class="stat-number-premium">11<sup>+</sup></div>
                        <div class="stat-label-premium">ЛЕТ ОПЫТА</div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="stat-box-premium">
                        <div class="stat-number-premium">500<sup>+</sup></div>
                        <div class="stat-label-premium">КЛИЕНТОВ</div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="stat-box-premium">
                        <div class="stat-number-premium">15<sup>+</sup></div>
                        <div class="stat-label-premium">СТАНКОВ</div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="stat-box-premium">
                        <div class="stat-number-premium">1000<sup>+</sup></div>
                        <div class="stat-label-premium">ПРОЕКТОВ</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="about-cta-premium">
                  <router-link to="/equipment" class="btn-premium">
                    <i class="fas fa-cogs me-2"></i>Наше оборудование
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Certification Section -->
    <section class="section certification-section">
      <div class="container">
        <div class="row justify-content-center text-center mb-5">
          <div class="col-lg-8" data-aos="fade-up">
            <h2 class="section-title">Сертификация</h2>
            <p class="section-subtitle">
              Работаем по международным стандартам качества. Вся продукция
              сертифицирована и соответствует требованиям ГОСТ и ISO
            </p>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100">
            <div class="certificate-card">
              <a href="/certs/1.pdf" target="_blank" class="certificate-link">
                <div class="certificate-preview">
                  <PdfThumbnail
                    pdfUrl="/certs/1.pdf"
                    previewImageUrl="/certs/1_preview-min.png"
                    name="Сертификат соответствия"
                  />
                </div>
                <div class="certificate-info">
                  <div class="certificate-id">№ 03878</div>
                  <div class="certificate-action">
                    <i class="fas fa-file-pdf"></i>
                    <span>Открыть PDF</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200">
            <div class="certificate-card">
              <a href="/certs/2.pdf" target="_blank" class="certificate-link">
                <div class="certificate-preview">
                  <PdfThumbnail
                    pdfUrl="/certs/2.pdf"
                    previewImageUrl="/certs/2_preview-min.png"
                    name="Сертификат соответствия"
                  />
                </div>
                <div class="certificate-info">
                  <div class="certificate-id">№ 0001992</div>
                  <div class="certificate-action">
                    <i class="fas fa-file-pdf"></i>
                    <span>Открыть PDF</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="300">
            <div class="certificate-card">
              <a href="/certs/3.pdf" target="_blank" class="certificate-link">
                <div class="certificate-preview">
                  <PdfThumbnail
                    pdfUrl="/certs/3.pdf"
                    previewImageUrl="/certs/3_preview-min.png"
                    name="Сертификат соответствия ISO"
                  />
                </div>
                <div class="certificate-info">
                  <div class="certificate-id">№ 2851</div>
                  <div class="certificate-action">
                    <i class="fas fa-file-pdf"></i>
                    <span>Открыть PDF</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Membership Section -->
    <section class="membership-section py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center" data-aos="fade-up">
            <p class="membership-caption mb-3">Член объединения</p>
            <a
              href="https://clasterunion.ru"
              target="_blank"
              rel="noopener noreferrer"
              class="membership-logo-link"
              aria-label="Деловое объединение кластеров России"
            >
              <img
                src="/img/union.png"
                alt="Деловое объединение кластеров России"
                class="membership-logo"
              />
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="container position-relative">
        <div class="row align-items-center">
          <div class="col-lg-8 mx-auto text-center" data-aos="fade-up">
            <div class="cta-badge mb-3">НАЧНИТЕ СОТРУДНИЧЕСТВО</div>
            <h2 class="cta-title mb-4">Готовы обсудить ваш проект?</h2>
            <p class="cta-text mb-5">Отправьте чертежи или эскизы — рассчитаем стоимость и сроки в течение дня. Бесплатный пробный образец для серийных заказов.</p>
            <div class="cta-buttons">
              <router-link to="/contacts" class="btn btn-light btn-lg">
                <i class="fas fa-paper-plane me-2"></i>Отправить запрос
              </router-link>
              <a href="tel:+79677700773" class="btn btn-outline-light btn-lg ms-3">
                <i class="fas fa-phone me-2"></i>+7 967 770 07 73
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Products Section -->
    <section class="section products-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center" data-aos="fade-up">
            <h2 class="section-title text-center">Наша продукция</h2>
            <p class="lead mb-5">Производим металлические изделия для автомобильной промышленности и товары народного потребления</p>
          </div>
        </div>

        <div class="row g-4">
          <div class="col-md-6" data-aos="fade-up" data-aos-delay="100">
            <router-link to="/products#auto-components" class="product-category-card">
              <div class="category-image" style="background-image: url('/img/auto_components/IMG_20230502_110557.jpg')"></div>
              <div class="category-overlay"></div>
              <div class="category-content">
                <div class="category-icon">
                  <i class="fas fa-car"></i>
                </div>
                <h3 class="category-title">Автомобильные компоненты</h3>
                <p class="category-description">Металлические детали и узлы для автомобильной промышленности</p>
                <span class="category-link">
                  Смотреть галерею <i class="fas fa-arrow-right"></i>
                </span>
              </div>
            </router-link>
          </div>
          <div class="col-md-6" data-aos="fade-up" data-aos-delay="200">
            <router-link to="/products#consumer-goods" class="product-category-card">
              <div class="category-image" style="background-image: url('/img/tovary_np/IMG_20230504_190939.jpg')"></div>
              <div class="category-overlay"></div>
              <div class="category-content">
                <div class="category-icon">
                  <i class="fas fa-box-open"></i>
                </div>
                <h3 class="category-title">Товары народного потребления</h3>
                <p class="category-description">Изделия из металла для повседневного использования</p>
                <span class="category-link">
                  Смотреть галерею <i class="fas fa-arrow-right"></i>
                </span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PdfThumbnail from '@/components/PdfThumbnail.vue'

export default {
  name: 'HomeView',
  components: {
    PdfThumbnail
  },
  data() {
    return {
      heroSlides: [
        { image: '/slide_1.png' },
        { image: '/slide_2.png' },
        { image: '/slide_3.png' }
      ]
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      if (window.Swiper) {
        new window.Swiper('.hero-swiper', {
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          effect: 'fade',
          fadeEffect: { crossFade: true },
        })
      }
    }
  },
  computed: {
    ...mapState(['services', 'products'])
  }
}
</script>

<style>
.hero {
  height: 705px;
  position: relative;
  max-width: 90%;
  border-radius: 30px;
  overflow: hidden;
  margin: 30px auto;
  background-color: #f8f9fa;
}

body {
  background-color: #f8f9fa;
}


.hero-slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.hero-swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: opacity 1s ease-in-out;
}

.swiper-pagination-bullet {
  background: #fff;
  opacity: 0.7;
}

.swiper-pagination-bullet-active {
  background: var(--primary-color);
  opacity: 1;
}

.swiper-button-prev,
.swiper-button-next {
  color: #fff;
  filter: drop-shadow(0 2px 8px rgba(0,0,0,0.25));
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.35) 100%);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  color: #fff;
  text-shadow: none;
}

.hero-title {
  font-size: 3.25rem;
  font-weight: 800;
  color: #fff;
  line-height: 1.2;
  position: relative;
  text-shadow: 0 2px 4px rgba(0,0,0,0.18);
}

.hero-subtitle {
  font-size: 1.25rem;
  color: rgba(255,255,255,0.92);
  max-width: 800px;
  margin: 0 auto 32px auto;
  text-shadow: 0 1px 2px rgba(0,0,0,0.13);
}

.hero-content .btn,
.hero-content .btn.btn-outline-light {
  box-shadow: 0 5px 15px rgba(0,0,0,0.18);
  border-radius: 16px;
  font-weight: 600;
  font-size: 1.13rem;
  padding: 0.95rem 2.8rem;
  border-width: 2px;
  transition: all 0.3s ease-in-out;
  letter-spacing: 0.5px;
}

.hero-content .btn-primary {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}

.hero-content .btn-primary:hover {
  background: #183f6d;
  border-color: #183f6d;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.25);
}

.hero-content .btn-outline-light {
  background: rgba(255,255,255,0.1);
  color: #fff;
  border-color: #fff;
  backdrop-filter: blur(4px);
}

.hero-content .btn-outline-light:hover {
  background: #fff;
  color: var(--primary-color);
  border-color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.2);
}

.services-section {
  background-color: #f9fafb;
  position: relative;
  padding: 100px 0 120px;
  border-radius: 0 0 30px 30px;
  margin-bottom: -30px;
}

.services-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 30px;
}

.service-card {
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.04);
  padding: 30px;
  height: 100%;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
  border: 1px solid rgba(0,0,0,0.03);
}

.service-card-with-bg {
  background-size: cover;
  background-position: center;
  border: none;
}

.service-icon {
  width: 70px;
  height: 70px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  background: linear-gradient(135deg, #f1f7ff, #e2efff);
  font-size: 28px;
  color: var(--primary-color);
  transition: all 0.3s ease;
}

.service-icon-on-bg {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  backdrop-filter: blur(5px);
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  border-color: rgba(26, 76, 138, 0.1);
}

.service-card:hover .service-icon {
  background: linear-gradient(135deg, #1a4c8a, #2c6cbd);
  color: white;
}

.service-card-with-bg:hover .service-icon {
  background: rgba(255, 255, 255, 0.3);
}

.service-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #1a3869;
}

.service-description {
  color: #555;
  margin-bottom: 25px;
  line-height: 1.6;
}

.service-link {
  color: var(--primary-color);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  text-decoration: none;
}

.service-link-on-bg {
  color: white;
}

.service-link:hover {
  color: #3a83f9;
}

.service-link-on-bg:hover {
  color: #8eb8ff;
}

.service-link .icon-arrow {
  transition: transform 0.3s ease;
}

.service-link:hover .icon-arrow {
  transform: translateX(8px);
}

.about-section {
  padding: 120px 0;
  background-color: #fff;
}

.about-badge {
  display: inline-block;
  background: linear-gradient(90deg, #f0f4f8, #e6eef9);
  color: var(--primary-color);
  padding: 8px 20px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 18px;
  letter-spacing: 0.5px;
  border: 1px solid rgba(0,0,0,0.1);
  box-shadow: 0 4px 12px rgba(26, 76, 138, 0.05);
}

.about-content {
  background-color: #fff;
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.about-main-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 24px 0 0 24px;
}

.about-text-container {
  padding: 70px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.divider {
  width: 70px;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-color), #3a83f9);
  margin-bottom: 30px;
  border-radius: 2px;
}

.about-paragraph {
  font-size: 16px;
  line-height: 1.9;
  color: #444;
  margin-bottom: 35px;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background-color: #f9fafb;
  border-radius: 16px;
  transition: all 0.3s ease;
}

.feature-item:hover {
  background-color: #f0f4f8;
  transform: translateX(5px);
}

.feature-icon {
  color: #fff;
  font-size: 18px;
  margin-right: 18px;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, var(--primary-color), #3a83f9);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-text {
  font-size: 16px;
  color: #343a40;
  font-weight: 500;
}

.stat-box {
  background-color: #f8f9fa;
  border-radius: 18px;
  padding: 24px;
  height: 100%;
  text-align: center;
  transition: all 0.4s ease;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.025);
}

.stat-box:hover {
  background: linear-gradient(135deg, var(--primary-color), #3a83f9);
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(26, 76, 138, 0.15);
}

.stat-box:hover .stat-number,
.stat-box:hover .stat-label {
  color: #fff;
}

.stat-number {
  font-size: 36px;
  font-weight: 800;
  background: linear-gradient(90deg, var(--primary-color), #3a83f9);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  margin-bottom: 10px;
  transition: all 0.4s ease;
  display: inline-block;
}

.stat-number sup {
  font-size: 17px;
  font-weight: 700;
}

.stat-label {
  font-size: 15px;
  color: #555;
  font-weight: 500;
  transition: all 0.3s ease;
}

.about-cta {
  margin-top: 40px;
  text-align: center;
}

.about-cta .btn {
  border-radius: 16px;
  padding: 12px 24px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.about-cta .btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
}

/* Premium About Section Styles */
.about-section-premium {
  padding: 120px 0;
  background: linear-gradient(180deg, #0a0d1a 0%, #0f1822 35%, #0a1320 65%, #060d18 100%);
  position: relative;
  overflow: hidden;
}

.about-section-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.02'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  pointer-events: none;
}

.about-badge-premium {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--primary-light);
  background: rgba(25, 118, 178, 0.15);
  border: 1px solid rgba(25, 118, 178, 0.3);
  padding: 8px 24px;
  border-radius: 30px;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin-bottom: 20px;
}

.about-title-premium {
  font-size: 3rem;
  font-weight: 300;
  color: #fff;
  margin-bottom: 20px;
  letter-spacing: 1px;
}

.highlight-brand {
  font-weight: 700;
  background: linear-gradient(135deg, var(--primary-light), #4da3ff);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}

.about-subtitle-premium {
  font-size: 1.15rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.7;
  font-weight: 300;
  max-width: 700px;
  margin: 0 auto;
}

.about-content-premium {
  background: linear-gradient(135deg, rgba(20, 25, 38, 0.85) 0%, rgba(15, 20, 32, 0.9) 100%);
  border: 1px solid rgba(25, 118, 178, 0.3);
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  position: relative;
}

.about-image-container-premium {
  position: relative;
  height: 100%;
  min-height: 600px;
  overflow: hidden;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(10, 13, 26, 0.3) 0%, rgba(15, 24, 34, 0.4) 100%);
  z-index: 1;
  pointer-events: none;
}

.video-frame {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  border: 1px solid rgba(25, 118, 178, 0.3);
  pointer-events: none;
  z-index: 2;
}

.about-text-container-premium {
  padding: 60px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.about-text-header-premium h3 {
  font-size: 1.8rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 20px;
  letter-spacing: 0.5px;
}

.divider-premium {
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, var(--primary-light), #4da3ff);
  margin-bottom: 30px;
}

.about-paragraph-premium {
  font-size: 1.05rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 35px;
  font-weight: 300;
}

.about-paragraph-premium strong {
  color: var(--primary-light);
  font-weight: 600;
}

.about-features-premium {
  margin-bottom: 35px;
}

.feature-item-premium {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding: 16px 20px;
  background: rgba(25, 118, 178, 0.08);
  border: 1px solid rgba(25, 118, 178, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.feature-item-premium:hover {
  background: rgba(25, 118, 178, 0.15);
  border-color: rgba(25, 118, 178, 0.4);
  transform: translateX(5px);
}

.feature-icon-premium {
  color: var(--primary-light);
  font-size: 18px;
  margin-right: 18px;
  width: 40px;
  height: 40px;
  background: rgba(25, 118, 178, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.feature-item-premium:hover .feature-icon-premium {
  background: rgba(25, 118, 178, 0.3);
  transform: scale(1.1);
}

.feature-text-premium {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
  line-height: 1.5;
}

.about-stats-premium {
  margin-bottom: 35px;
}

.stat-box-premium {
  background: rgba(25, 118, 178, 0.08);
  border: 1px solid rgba(25, 118, 178, 0.25);
  border-radius: 16px;
  padding: 24px;
  height: 100%;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.stat-box-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, var(--primary-light) 50%, transparent 100%);
  opacity: 0;
  transition: opacity 0.4s;
}

.stat-box-premium:hover {
  background: rgba(25, 118, 178, 0.15);
  border-color: rgba(25, 118, 178, 0.5);
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(25, 118, 178, 0.2);
}

.stat-box-premium:hover::before {
  opacity: 0.8;
}

.stat-number-premium {
  font-size: 3rem;
  font-weight: 200;
  color: var(--primary-light);
  margin-bottom: 10px;
  line-height: 1;
  font-family: Georgia, serif;
  letter-spacing: -1px;
}

.stat-number-premium sup {
  font-size: 1.3rem;
  font-weight: 300;
}

.stat-label-premium {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 500;
}

.about-cta-premium {
  margin-top: 40px;
  text-align: center;
}

.btn-premium {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(25, 118, 178, 0.2) 0%, rgba(10, 77, 119, 0.15) 100%);
  border: 1px solid rgba(25, 118, 178, 0.4);
  color: var(--primary-light);
  padding: 14px 35px;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  border-radius: 12px;
  text-decoration: none;
  font-size: 1rem;
}

.btn-premium:hover {
  background: linear-gradient(135deg, rgba(25, 118, 178, 0.3) 0%, rgba(10, 77, 119, 0.25) 100%);
  border-color: var(--primary-light);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(25, 118, 178, 0.3);
}

/* Membership Section */
.membership-section {
  background-color: #ffffff;
}

.membership-caption {
  font-size: 0.85rem;
  letter-spacing: 0.15em !important;
  text-transform: uppercase;
  color: var(--gray-color);
  margin: 0;
}

.membership-logo-link {
  display: inline-block;
  transition: var(--transition);
}

.membership-logo-link:hover,
.membership-logo-link:focus {
  transform: translateY(-2px);
  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.12));
}

.membership-logo {
  max-width: 100%;
  width: auto;
  height: auto;
  max-height: 90px;
  display: block;
  margin: 0 auto;
}

@media (max-width: 575.98px) {
  .membership-logo {
    max-height: 60px;
  }
}

/* CTA Section - Premium Style */
.cta-section {
  position: relative;
  padding: 120px 0;
  color: #fff;
  overflow: hidden;
  background: linear-gradient(180deg, #0a0d1a 0%, #0f1822 35%, #0a1320 65%, #060d18 100%);
}

.cta-section .container {
  position: relative;
  z-index: 2;
}

.cta-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--primary-light);
  background: rgba(25, 118, 178, 0.15);
  border: 1px solid rgba(25, 118, 178, 0.3);
  padding: 8px 24px;
  border-radius: 30px;
  text-transform: uppercase;
  letter-spacing: 3px;
}

.cta-title {
  font-size: 2.8rem;
  font-weight: 300;
  letter-spacing: 1px;
  color: #fff;
}

.cta-text {
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.8;
  font-weight: 300;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.cta-buttons .btn {
  background: transparent;
  border: 1px solid rgba(25, 118, 178, 0.35);
  color: var(--primary-light);
  padding: 14px 35px;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s;
  border-radius: 12px;
}

.cta-buttons .btn:hover {
  background: rgba(25, 118, 178, 0.12);
  border-color: var(--primary-light);
  color: var(--primary-light);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(25, 118, 178, 0.2);
}

.cta-buttons .btn.btn-light {
  background: linear-gradient(135deg, rgba(25, 118, 178, 0.18) 0%, rgba(10, 77, 119, 0.12) 100%);
  border-color: rgba(25, 118, 178, 0.4);
}

.cta-buttons .btn.btn-light:hover {
  background: linear-gradient(135deg, rgba(25, 118, 178, 0.28) 0%, rgba(10, 77, 119, 0.22) 100%);
  border-color: var(--primary-light);
}

.partners-section {
  background-color: #f8f9fa;
  padding: 60px 0;
}

.partners-container {
  margin-top: 20px;
}

.partner-item {
  background-color: #fff;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.04);
  padding: 30px 20px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border: 1px solid rgba(0,0,0,0.03);
}

.partner-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.08);
  border-color: rgba(26, 76, 138, 0.1);
}

.partner-name {
  font-size: 18px;
  font-weight: 600;
  color: #1a3869;
  text-align: center;
  transition: color 0.3s ease;
}

.partner-item:hover .partner-name {
  color: var(--primary-color);
}

.products-section {
  background-color: #f9fafb;
  position: relative;
}

.product-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.02);
}

.product-card:hover {
  transform: translateY(-15px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
  border-color: rgba(0, 0, 0, 0);
}

.product-image {
  height: 220px;
  overflow: hidden;
  position: relative;
}

.product-image:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0));
  transition: all 0.3s ease;
}

.product-card:hover .product-image:after {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.product-card:hover .product-image img {
  transform: scale(1.12);
}

.product-info {
  padding: 25px;
}

.product-title {
  font-weight: 700;
  font-size: 1.25rem;
  margin-bottom: 12px;
  color: var(--dark-color);
  transition: all 0.3s ease;
}

.product-card:hover .product-title {
  color: var(--primary-color);
}

.product-description {
  color: var(--gray-color);
  margin-bottom: 20px;
  line-height: 1.7;
}

.product-link {
  color: var(--primary-color);
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  transition: all 0.3s ease;
}

.product-link svg {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.product-link:hover {
  color: var(--primary-light);
}

.product-link:hover svg {
  transform: translateX(8px);
}

.certification-section {
  background-color: #f8f9fa;
  padding: 100px 0;
  position: relative;
}

.section-subtitle {
  font-size: 18px;
  color: #555;
  max-width: 800px;
  margin: 0 auto 30px;
  line-height: 1.6;
}

.certificate-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 15px 35px rgba(0,0,0,0.06);
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
  border: 1px solid rgba(0,0,0,0.03);
}

.certificate-card:hover {
  transform: translateY(-7px);
  box-shadow: 0 25px 45px rgba(0,0,0,0.12);
}

.certificate-link {
  display: block;
  color: inherit;
  text-decoration: none;
  height: 100%;
}

.certificate-preview {
  padding: 30px 20px;
  text-align: center;
  background: linear-gradient(135deg, #f9f9f9, #f0f4f8);
  border-bottom: 1px solid rgba(0,0,0,0.04);
  border-radius: 20px 20px 0 0;
}

.certificate-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
  filter: drop-shadow(0 3px 6px rgba(0,0,0,0.1));
  transition: transform 0.3s ease;
}

.certificate-card:hover .certificate-icon {
  transform: scale(1.1);
}

.certificate-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.certificate-info {
  padding: 20px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.certificate-id {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.certificate-action {
  color: var(--primary-color);
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: color 0.2s ease;
}

.certificate-card:hover .certificate-action {
  color: #3a83f9;
}

/* Premium About Section - Responsive */
@media (max-width: 991.98px) {
  .about-section-premium {
    padding: 80px 0;
  }

  .about-title-premium {
    font-size: 2.2rem;
  }

  .about-subtitle-premium {
    font-size: 1rem;
  }

  .about-image-container-premium {
    min-height: 400px;
  }

  .about-text-container-premium {
    padding: 40px;
  }

  .about-text-header-premium h3 {
    font-size: 1.5rem;
  }

  .about-paragraph-premium {
    font-size: 1rem;
  }

  .stat-number-premium {
    font-size: 2.5rem;
  }
}

@media (max-width: 767.98px) {
  .about-section-premium {
    padding: 60px 0;
  }

  .about-badge-premium {
    font-size: 0.65rem;
    padding: 6px 18px;
    letter-spacing: 2px;
  }

  .about-title-premium {
    font-size: 1.8rem;
  }

  .about-subtitle-premium {
    font-size: 0.95rem;
  }

  .about-content-premium {
    border-radius: 16px;
  }

  .about-image-container-premium {
    min-height: 300px;
  }

  .about-text-container-premium {
    padding: 30px 25px;
  }

  .about-text-header-premium h3 {
    font-size: 1.3rem;
  }

  .divider-premium {
    width: 50px;
    margin-bottom: 20px;
  }

  .about-paragraph-premium {
    font-size: 0.95rem;
    margin-bottom: 25px;
  }

  .feature-item-premium {
    padding: 12px 15px;
    margin-bottom: 12px;
  }

  .feature-icon-premium {
    width: 35px;
    height: 35px;
    font-size: 16px;
  }

  .feature-text-premium {
    font-size: 0.9rem;
  }

  .stat-box-premium {
    padding: 20px 15px;
  }

  .stat-number-premium {
    font-size: 2rem;
  }

  .stat-number-premium sup {
    font-size: 1rem;
  }

  .stat-label-premium {
    font-size: 0.7rem;
  }

  .btn-premium {
    padding: 12px 28px;
    font-size: 0.95rem;
  }

  .video-frame {
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
  }

  .cta-section {
    padding: 80px 0;
  }

  .cta-title {
    font-size: 2.2rem;
  }

  .cta-text {
    font-size: 1rem;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .cta-buttons .btn {
    width: 100%;
    margin: 0 !important;
  }
}

@media (max-width: 991.98px) {
  .services-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  .about-text-container {
    padding: 40px;
  }

  .about-main-video {
    border-radius: 24px 24px 0 0;
  }
}

@media (max-width: 575.98px) {
  .services-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .service-card {
    padding: 28px;
  }

  .about-text-container {
    padding: 30px;
  }

  .feature-item {
    padding: 12px 16px;
  }
}

@media (max-width: 767.98px) {
  .partner-item {
    padding: 20px 15px;
  }

  .partner-name {
    font-size: 16px;
  }
}

@media (max-width: 991.98px) {
  .hero {
    height: auto;
    padding: 120px 0 100px;
  }

  .hero-title {
    font-size: 2.75rem;
  }
  
  .hero-content .d-flex {
    flex-direction: column;
    width: 100%;
    gap: 15px !important;
  }
  
  .hero-content .btn {
    width: 100%;
    margin: 0 !important;
  }

  .cta-section {
    margin: 0;
    padding: 50px 30px;
    border-radius: 0;
  }
}

@media (max-width: 767.98px) {
  .hero-title {
    font-size: 2.25rem;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
  }

  .service-card,
  .product-card {
    padding: 25px;
  }
  
  .company-description,
  .tech-description {
    font-size: 1rem;
  }
}

@media (max-width: 991.98px) {
  .certification-section {
    padding: 80px 0;
  }
}

@media (max-width: 575.98px) {
  .hero {
    margin: 15px;
    border-radius: 20px;
    padding: 100px 0 80px;
  }
  
  .hero-title {
    font-size: 1.85rem;
  }
  
  .hero-subtitle {
    font-size: 1rem;
  }
  
  .hero-content .btn {
    font-size: 1rem;
    padding: 0.85rem 2rem;
  }

  .certification-section {
    padding: 60px 0;
  }

  .certificate-preview {
    padding: 25px 15px;
  }

  .certificate-icon {
    width: 70px;
    height: 70px;
  }

  .certificate-name {
    font-size: 16px;
  }

  .certificate-info {
    padding: 15px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

/* Product Category Cards */
.products-section {
  padding: 100px 0;
  background: #f9fafb;
}

.product-category-card {
  display: block;
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  height: 380px;
  text-decoration: none;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
  transition: all 0.4s ease;
}

.product-category-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.category-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: transform 0.6s ease;
}

.product-category-card:hover .category-image {
  transform: scale(1.1);
}

.category-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.7) 100%);
  transition: background 0.4s ease;
}

.product-category-card:hover .category-overlay {
  background: linear-gradient(180deg, rgba(26,76,138,0.3) 0%, rgba(10,19,32,0.85) 100%);
}

.category-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px;
  z-index: 2;
  color: #fff;
}

.category-icon {
  width: 60px;
  height: 60px;
  background: rgba(255,255,255,0.15);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255,255,255,0.2);
}

.product-category-card:hover .category-icon {
  background: var(--primary-color);
  border-color: var(--primary-color);
  transform: scale(1.1);
}

.category-title {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 10px;
  color: #fff;
}

.category-description {
  font-size: 1rem;
  color: rgba(255,255,255,0.8);
  margin-bottom: 20px;
  line-height: 1.5;
}

.category-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.category-link i {
  transition: transform 0.3s ease;
}

.product-category-card:hover .category-link {
  color: var(--primary-light);
}

.product-category-card:hover .category-link i {
  transform: translateX(5px);
}

@media (max-width: 767.98px) {
  .product-category-card {
    height: 300px;
  }
  
  .category-content {
    padding: 30px;
  }
  
  .category-icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
  
  .category-title {
    font-size: 1.3rem;
  }
  
  .category-description {
    font-size: 0.9rem;
  }
}
</style>
